import React, { Component } from 'react';

import Button from '../button/Button';
import FormSubmitAgreement from './FormSubmitAgreement';
import './style.css';


export default class FormSubmit extends Component {
  render() {
    const blockClasses = this.props.blockClasses ? this.props.blockClasses.join(' ') : '';
    const buttonClasses = this.props.buttonClasses ? this.props.buttonClasses : [];
    return (
      <div className={blockClasses + ' form__submit-container'}>
        <Button
          styleClasses={buttonClasses.concat(['form__button'])}
          onClick={this.props.onClick}
        >
          {this.props.children}
        </Button>
        <FormSubmitAgreement/>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/blocks/form-blocks/FormSubmit.js